import { Link } from "react-router-dom";
import { SITE } from "../data/site";
import Seo from "../Components/Seo";
import Reveal from "../Components/Reveal";

export default function Imprint() {
  return (
    <>
      <Seo
        title="Impressum"
        description="Impressum von CCS Gebäudemanagement, Ismail Cana, Mülheim an der Ruhr."
        path="/impressum"
      />
      <header className="page-hero">
        <div className="wrap">
          <p className="kicker" style={{ color: "var(--cyan)" }}>
            Angaben gemäß § 5 TMG
          </p>
          <h1 className="display">Wer hinter CCS steht.</h1>
          <p>
            Name, Anschrift, Kontakt und Register – vollständig und ohne
            Kleingedrucktes.
          </p>
        </div>
      </header>
      <section className="section">
        <div className="wrap imprint">
          <Reveal className="imprint-card">
            <p className="kicker">Unternehmen</p>
            <h2>{SITE.name}</h2>
            <dl className="imprint-meta">
              <div>
                <dt>Inhaber</dt>
                <dd>{SITE.owner}</dd>
              </div>
              {SITE.addresses.map((a) => (
                <div key={a.label}>
                  <dt>{a.label}</dt>
                  <dd>
                    {a.street}
                    <br />
                    {a.zip} {a.city}
                  </dd>
                </div>
              ))}
              <div>
                <dt>Telefon</dt>
                <dd>
                  <a href={`tel:${SITE.phoneTel}`}>{SITE.phoneDisplay}</a>
                </dd>
              </div>
              <div>
                <dt>E-Mail</dt>
                <dd>
                  <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
                </dd>
              </div>
              <div>
                <dt>Handelsregister</dt>
                <dd>
                  {SITE.legal.court}
                  <br />
                  {SITE.legal.hrb}
                </dd>
              </div>
              <div>
                <dt>Umsatzsteuer</dt>
                <dd>
                  Nr. {SITE.legal.vat}
                  <br />
                  USt-IdNr. {SITE.legal.vat}
                </dd>
              </div>
            </dl>
          </Reveal>

          <Reveal className="imprint-note" delay={80}>
            <p className="kicker">Verbraucherstreitbeilegung</p>
            <p>
              Wir sind nicht bereit oder verpflichtet, an
              Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
              teilzunehmen.
            </p>
          </Reveal>

          <Reveal className="imprint-actions" delay={100}>
            <Link className="btn btn-navy" to="/kontakt">
              Kontakt aufnehmen
            </Link>
            <Link className="btn btn-line" to="/datenschutz">
              Datenschutz
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
